/**
 * Notification preferences stored on Users/{uid}.notificationSettings.
 * Firestore rules: authenticated users can read/write their own
 * Users/{uid}.notificationSettings (or full document if already allowed).
 */

export interface ChannelFlags {
  push: boolean;
  email: boolean;
}

export const NOTIFICATION_TOPICS = ["new_job_ads", "unread_message_reminders", "lead_status_updates"] as const;

export type TopicKey = (typeof NOTIFICATION_TOPICS)[number];

export interface NotificationSettings {
  topics: Record<TopicKey, ChannelFlags>;
  jobMatchesFrequency?: "instant" | "daily" | "weekly";
}

export const DEFAULT_NOTIFICATION_SETTINGS: NotificationSettings = {
  topics: Object.fromEntries(
    NOTIFICATION_TOPICS.map((t) => [t, { push: true, email: true }])
  ) as Record<TopicKey, ChannelFlags>,
  jobMatchesFrequency: "instant",
};
